"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
const validate_1 = require("@App/helpers/validate");
const SearchResult_1 = __importDefault(require("@Components/WorkRegistrationSubs/SearchResult"));
require("./index.scss");
const contexts_1 = require("@App/contexts");
const removers_1 = require("@App/helpers/work-entities/removers");
const publisher_side_bar_state_1 = require("@App/enum/publisher-side-bar-state");
const format_name_1 = require("@App/helpers/format-name");
const WriterSideBar = ({ data }) => {
    const { workStore, popupStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [workWriters, setWorkWriters] = (0, react_1.useState)([]);
    const getWorkWriters = () => {
        if (!workStore.workDraftLocal) {
            return;
        }
        const linkedWriters = data.writers;
        const newWorkWriters = workStore.workDraftLocal.writers;
        if (linkedWriters.length) {
            setWorkWriters(newWorkWriters.filter((newWorkWriter) => {
                const coincidence = !!linkedWriters.filter((linkedWriter) => linkedWriter.localId === newWorkWriter.localId).length;
                if (coincidence) {
                    return;
                }
                return newWorkWriter;
            }));
            return;
        }
        setWorkWriters(newWorkWriters);
    };
    (0, react_1.useEffect)(() => {
        getWorkWriters();
    }, []);
    const addWriter = (addingWriter) => {
        const workDraftFromLocal = workStore.workDraftLocal;
        const { id, localId, publisherName, ipiNumber, amend, publisherShare, administratorPublishers, writers, hfaPublisherNumber, } = data;
        if (!workDraftFromLocal || !localId || !addingWriter) {
            return;
        }
        const originalPublishers = workDraftFromLocal.originalPublishers;
        const indexOfOP = originalPublishers.map((op) => op.localId).indexOf(localId);
        const linkedWriters = [...writers, addingWriter];
        const updatedOriginalPublisher = Object.assign(Object.assign({}, data), { id: id, localId: localId, publisherName: publisherName, ipiNumber: ipiNumber, amend: amend, publisherShare: publisherShare, administratorPublishers: administratorPublishers, writers: linkedWriters, hfaPublisherNumber: hfaPublisherNumber });
        const updatedOPArray = (0, removers_1.setItemToArrayByIndex)(originalPublishers, +indexOfOP, updatedOriginalPublisher);
        const updatedWorkDraft = Object.assign(Object.assign({}, workDraftFromLocal), { originalPublishers: updatedOPArray });
        workStore.setWorkDraftToLocal(updatedWorkDraft);
        const newWorkWriters = workWriters.filter((workWriter) => workWriter.localId !== addingWriter.localId);
        setWorkWriters(newWorkWriters);
        popupStore.setPublisherSidebarState(publisher_side_bar_state_1.PublisherSideBarState.empty);
    };
    const isValidIPI = (ipiNumber) => (ipiNumber ? (0, validate_1.IPIValidator)(ipiNumber, true) : true);
    const workWriterRoles = (workWriter) => isValidIPI(workWriter.ipiNumber) && workWriter.ipiNumber
        ? [{ name: 'IPI Number', value: workWriter.ipiNumber }]
        : [];
    return (react_1.default.createElement("div", { className: "link-writer-to-op" },
        react_1.default.createElement("h2", null, "Link Writer"),
        react_1.default.createElement("div", null, "Select one or more writers below to link them to the publisher/administrator listed on this work."),
        workWriters && workWriters.length ? (workWriters.map((workWriter, index) => {
            var _a;
            return (react_1.default.createElement(SearchResult_1.default, { key: (_a = workWriter.ipId) !== null && _a !== void 0 ? _a : index, title: workWriter.lastName ? (0, format_name_1.formatName)(workWriter.firstName, workWriter.lastName) : '___', onAddClicked: () => addWriter(workWriter), onItemWasAdded: () => false, roles: workWriterRoles(workWriter), addButtonText: 'Link writer' }));
        })) : (react_1.default.createElement("p", null, "No writers left to add."))));
};
exports.default = (0, mobx_react_1.observer)(WriterSideBar);
